module.exports = __webpack_public_path__ + "img/stresa_hero_card.314f8a51.png";